<script setup lang="ts">
import {ref, watch} from "vue";
import Dosage from "@/dosage/interfaces/Dosage";
import {dosageApi} from "@/container";
import {Select, SelectTrigger, SelectValue, SelectContent, SelectItem} from "@/core/components/ui/select";
import DosageService from "@/dosage/services/DosageService";
import {Button} from "@/core/components/ui/button";

const props = defineProps<{
    productId: number
}>();

const templates = ref<Dosage[]>();
const loading = ref(false);
const selectedTemplate = ref<string | undefined>(undefined);

const emit = defineEmits<{
    (e: 'select', template: Dosage): void
}>();

watch(
    () => props.productId,
    (id) => {
        if (id) {
            templates.value = [];
            loading.value = true;
            dosageApi()
                .dosageTemplates(id)
                .then((response) => {
                    if (Object.keys(response)?.length > 0) {
                        templates.value = Object.values(response).flat();
                        selectedTemplate.value = templates.value[0]?.id.toString() || undefined;
                    }
                })
                .finally(() => {
                    loading.value = false;
                });
        }
    }, {immediate: true});

/**
 * Submit the selected template.
 */
const submitSelect = () => {
    const template = templates.value?.find(t => t.id.toString() === selectedTemplate.value);

    if (template) {
        emit('select', template);
    }
};
</script>
<template>
  <div v-if="templates?.length" class="bg-white flex items-center px-3 gap-1 rounded-lg shadow-[5px_5px_0_0_#3513e2]">
    <div class="gradient text-white text text-sm font-bold px-2 rounded-md">
      SUGGESTIONS
    </div>
    <Select v-model:model-value="selectedTemplate">
      <SelectTrigger class="shadow-none border-0 flex-1 [&>span]:line-clamp-1 [&>span]:whitespace-break-spaces pr-0">
        <SelectValue placeholder="Sélectionnez un modèle" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem
          v-for="template in (templates ?? [])" :key="template.id" class="hover:bg-gray-100 cursor-pointer"
          :value="template.id.toString()"
        >
          {{ DosageService.humanizeDosage(template) }}
        </SelectItem>
      </SelectContent>
    </Select>
    <Button variant="ghost" class="text-primary" :disabled="!selectedTemplate" @click="submitSelect">
      Utiliser
    </Button>
  </div>
</template>

<style scoped>

</style>
